// src/Router.tsx
import { Navigate, useRoutes } from "react-router-dom";
import { DashboardLayout } from "./layouts/dashboard/DashboardLayout";
import EmptyLayout from "./layouts/EmptyLayout";
import React, { Suspense, lazy } from "react";
import { getUserKeyLocalStorage } from "./api/LocalEnvironmentClient";
import AdminPage from "./pages/admin/Admin";

// Lazy-loaded components
const NotFoundPage = lazy(() => import("./pages/404/NotFound"));
const BioPage = lazy(() => import("./pages/bio/Bio"));
const BlogPage = lazy(() => import("./pages/blog/Blog"));
const BlogPost = lazy(() => import("./pages/blog/BlogPost"));
const BooksPage = lazy(() => import("./pages/books/Books"));
const DashboardPage = lazy(() => import("./pages/dashboard/Dashboard"));
const HomePage = lazy(() => import("./pages/home/Home"));
const DailyUpdatePage = lazy(() => import("./pages/daily/DailyUpdatePage"));
const RecipesPage = lazy(() => import("./pages/recipes/Recipes"));

export default function Router() {
  const isAuthorized =
    getUserKeyLocalStorage() === process.env.REACT_APP_USER_KEY;

  const routes = [
    {
      path: "/dashboard",
      element: <DashboardLayout isAuthorized={isAuthorized} />,
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<div />}>
              <DashboardPage />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "/generate-image",
      element: <DashboardLayout isAuthorized={isAuthorized} />,
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<div />}>
              <DashboardPage widgetType={"generate-image"} />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "/itinerary",
      element: <DashboardLayout isAuthorized={isAuthorized} />,
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<div />}>
              <DashboardPage widgetType={"itinerary"} />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "/books",
      element: <DashboardLayout isAuthorized={isAuthorized} />,
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<div />}>
              <BooksPage />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "/daily",
      element: <DashboardLayout isAuthorized={isAuthorized} />,
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<div />}>
              <DailyUpdatePage />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "/recipes",
      element: <DashboardLayout isAuthorized={isAuthorized} />,
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<div />}>
              <RecipesPage />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "/bio",
      element: <DashboardLayout isAuthorized={isAuthorized} />,
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<div />}>
              <BioPage />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "/admin",
      element: <DashboardLayout isAuthorized={isAuthorized} />,
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<div />}>
              <AdminPage isAuthorized={isAuthorized} />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "/blog",
      element: <DashboardLayout isAuthorized={isAuthorized} />,
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<div />}>
              <BlogPage />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "/blog/:id",
      element: <DashboardLayout isAuthorized={isAuthorized} />,
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<div />}>
              <BlogPost />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "/",
      element: <DashboardLayout isAuthorized={isAuthorized} />,
      children: [
        {
          path: "/",
          element: (
            <Suspense fallback={<div />}>
              <HomePage />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "/404",
      element: <EmptyLayout />,
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<div />}>
              <NotFoundPage />
            </Suspense>
          ),
        },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ];

  return useRoutes(routes);
}
